import { useState } from "react";
import { Box, Button, Paper, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useApp from "../../../hooks/useApp";
import DateRange from "../DateRange/DateRange";

interface Props {
  title: string;
  selection: string;
}

const DateRangePickerNew: React.FC<Props> = ({ title, selection }) => {
  const { hideDeletePopup, dateRange, changeDateRange } = useApp();
  const tablet = useMediaQuery((theme: any) => theme.breakpoints.down("md"));

  // react-date-range in range mode keeps the previous endDate on the first
  // click — so picking a past day yields [clicked, today] instead of a single
  // day. Track clicks per session so the first click collapses to a single
  // day and a second click (if any) extends the range.
  const [clickCount, setClickCount] = useState(0);

  const handleChange = (item: any) => {
    const next = item.selection;

    if (selection === "Single" || clickCount === 0) {
      changeDateRange([
        {
          startDate: next.startDate,
          endDate: next.startDate,
          key: "selection",
        },
      ]);
      setClickCount(1);
      if (selection === "Single") hideDeletePopup();
      return;
    }

    // Second click in a "Multiple" session — accept the range the picker
    // produced. The user can click "OK" to confirm or keep clicking to revise.
    changeDateRange([next]);
    setClickCount(0);
  };

  return (
    <Box
      sx={{
        width: "90%",
        maxWidth: 892,
        position: "relative",
        top: "50%",
        transform: "translateY(-50%)",
        "& .rdrDefinedRangesWrapper": {
          display: { xs: "none", md: "block" },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "grey.300",
          padding: "8px 16px",
          color: "black",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <CloseIcon
          aria-label="close modal"
          onClick={hideDeletePopup}
          sx={{ cursor: "pointer" }}
        />
      </Box>
      <Paper
        square
        elevation={0}
        sx={{ border: "1px solid", borderColor: "divider" }}
      >
        <DateRange
          setLimit={false}
          state={dateRange}
          handleChange={(item: any) => handleChange(item)}
          months={tablet ? 1 : 2}
        />
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "flex-end",
            borderTop: (theme) => `1px solid ${theme.palette.grey[300]}`,
          }}
        >
          <Button
            disableElevation
            variant="text"
            size="small"
            onClick={hideDeletePopup}
          >
            Cancel
          </Button>
          {selection === "Multiple" && (
            <Button
              disableElevation
              variant="text"
              size="small"
              onClick={hideDeletePopup}
              sx={{ ml: 2 }}
            >
              OK
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default DateRangePickerNew;
